<template>
  <div class="not-found">
    <img src="../assets/img/not-found.png"/>
    <p class="ch-p">很抱歉！您要访问的页面不存在。</p>
    <p class="en-p">
      Page Not Found！The page you are looking for does’t seem to exist...
    </p>
  </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
  name: 'NotFound',
});
</script>

<style scoped lang="less">
@import "../assets/css/not-found.less";
</style>